import SearchField from './Filters/SearchField'
import FilterPills from './Filters/FilterPills'
import AddFilterButton from './Filters/AddFilterButton'

export default function Filters() {

  return (
    <div className='filters-container'>
      <div className='main-row'>
        <SearchField />
        <AddFilterButton />
      </div>
      <FilterPills />
    </div>
  )
}
